import { JSX, ReactElement } from "react";

import { Box, Stack } from "@mui/material";

type SectionHeaderProps = {
  icon: JSX.Element;
  title: string | JSX.Element;
  buttons?: ReactElement[];
};

const SectionHeader = (props: SectionHeaderProps) => {
  const { icon, title, buttons } = props;

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" alignItems="center">
        <Box
          component="span"
          sx={{
            mr: 1,
            color: "primary.main",
            display: "flex",
          }}
        >
          {icon}
        </Box>

        <h2>{title}</h2>
      </Stack>

      {!!buttons && (
        <Stack direction="row" alignItems="center" spacing={2}>
          {buttons.map((button) => button)}
        </Stack>
      )}
    </Stack>
  );
};
export default SectionHeader;
